export default "__VITE_ASSET__BRx7MxYs__"